<template>
  <div class="input">
    <div class="input-label">言語</div>
    <div class="input-group">
      <input-select
        :option="locale"
        :options="locales"
        @select="(o) => locale = o" />
    </div>
  </div>
</template>

<script>
import InputSelect from '@/components/Input/Select'

export default {
  components: {
    InputSelect,
  },

  data () {
    return {
      locales: [
        { id: 1, locale: 'ja', get: ()=>{ return '日本語' }, },
        { id: 2, locale: 'en', get: ()=>{ return 'English' }, },
      ],
    }
  },

  computed: {
    locale: {
      get: function () {
        let locale = this.$store.state.app.locale
        return this.locales.find((o) => locale == o.locale)
      },
      set: function (value) {
        this.$store.commit('app/setLocale', value.locale)
      },
    },
  },
}
</script>


<style lang="scss" scoped>
@import '@/styles/_form.scss';
.select-suit {
  @include input-select
  width: 30%;

  &-frame {
    @include input-select-frame;
  }

  &-option {
    @include input-select-option;
  }
}
</style>
